import React from "react";

const CryptoDetails = () => {
    return (
        <div>
            <p>
                CryptoDetails
            </p>
        </div>
    )
}

export default CryptoDetails; 